<template>
  <div class="container">
    <div class="banner" :style="'background-image:url('+ bannerUrl +')'">
      <Nav></Nav> 
    </div>
      <!--中间部分-->
      <div class="position">您的位置 ：<span>联系我们</span></div>
      <div class="middle">
        <div class="top">
          <div class="erweima">
            <img :src="wchat" alt="">
          </div>
          <div class="fangshi">
            <ul>
              <li><img src="../../assets/tel_06.png">&nbsp;&nbsp;&nbsp;<a :href="'tel:'+ tel +''">TEL：{{tel}}</a></li>
              <li><span><img src="../../assets/dili_09.png"></span>&nbsp;&nbsp;&nbsp;<span class="texthidden">ADD：{{address}}</span></li>
              <li><img src="../../assets/youxiang_12.png">&nbsp;&nbsp;&nbsp;<a :href="'mailto:'+ email +''">EMAIL：{{email}}</a></li>
            </ul>
          </div>
          <div class="konglong">
            <img src="../../assets/konglong_03.png" alt="">
          </div>
        </div>
        <div class="buttom">
          <div class="ditu">
             <div id="map"></div>
          </div>
        </div>
      </div>
      <!--底部-->
       <Footer></Footer>
  </div>
</template>
<script>
import Nav from '../../components/Nav'
import Footer from '../../components/Footer'
export default {
  components:{Nav,Footer},
  name:'Contact',
  data(){
    return{
      id:'',
      address:"",
      tel:"",
      email:'',
      add_content:'',
      wchat:'',
      bannerUrl:'',
      latitude:'',//纬度,
      longitude:'',//经度
      title:""

    }
  },
  mounted(){
       
  },
  methods:{
      getList () {
      this.$http.post('/api/contact/getInfo', {
        id:this.id
      }).then( (res)=> {
        var code=res.data.code;
        if(code===0){
          this.bannerUrl = res.data.data.banner
          this.id=res.data.data.contact.id
          this.address=res.data.data.contact.address
          // console.log(this.address)
          this.email=res.data.data.contact.email
          this.tel=res.data.data.contact.tel
          this.wchat=res.data.data.contact.wchat
          this.add_content=res.data.data.contact.add_content
          this.title=res.data.data.contact.title
          this.latitude=res.data.data.contact.latitude//纬度
          this.longitude=res.data.data.contact.longitude//经度
          var map = new BMap.Map('map');
          var point = new BMap.Point(this.longitude,this.latitude);
          map.centerAndZoom(point, 15);
          map.enableScrollWheelZoom(true);
          var content = this.add_content;
          //创建检索信息窗口对象
          var searchInfoWindow = null;
          searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
              title: this.title, 
              width: 100, //宽度
              height: 80, //高度
              enableAutoPan: true, //自动平移
              searchTypes: [
                  BMAPLIB_TAB_TO_HERE, //到这里去
                  BMAPLIB_TAB_SEARCH, //周边检索
                  BMAPLIB_TAB_FROM_HERE //从这里出发
              ]
          });
          var marker = new BMap.Marker(point); //创建marker对象
          marker.enableDragging(false); //marker可拖拽
          marker.addEventListener("click", function(e) {
              searchInfoWindow.open(marker);
          })
          map.addOverlay(marker); //在地图中添加marker
          searchInfoWindow.open(marker); //在marker上打开检索信息串口
        }
      }).catch(function (error) {
        //  console.log(error);
     });

  },
  },
  created(){
    this.getList()
    //  console.log(this.longitude,this.latitude)
  }
}
</script>
<style scoped>
.container{
 background-color:rgb(244,247,250);
 min-width: max-content;
 min-width: -moz-max-content;
}
.BMapLib_SearchInfoWindow{
  border-radius: 15px;
}
.ditu{
   width: 1105px;
  height: 576px;
  z-index: 1000;
  margin: 0 auto;
  margin-top: 35px;
  
}
.BMap_bubble_max_content{
  display: block !important;
}
.BMap_bubble_title,.BMap_bubble_content{
  text-align: center !important;
}
.BMap_bubble_title{
  color:rgb(246, 170, 0)  !important;
}
#map{
  width: 1105px;
  height: 576px;
  margin: 0 auto;
  border-radius: 25px;
  /* margin-top: 0.5rem; */
}
.banner{
  overflow: hidden !important;
}
.banner{
  position: relative;
  background-image: url('../../assets/banner7.png');
  width: 100%;
  min-width: 1200px;
  height: 366px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
.position{
  margin: 0 auto;
  width: 990px;
  text-align: right;
  margin-top: 40px;
  color: rgb(164, 164, 164);
  font-size: 16px;
  }
  .position span{
    color: rgb(247, 184, 46)
  }
  .middle{
    width: 1200px;
    margin: 0 auto;
    margin-top: 40px;
    background-color: white;
    border-radius: 35px;
    margin-bottom: -350px;
    padding-bottom: 390px;
  }
  .top{
    /* height: 230px; */
    /* background: yellow; */
    display: flex;
    justify-content: space-around;
    padding-top:70px;
  }
  .texthidden{
     overflow: hidden;
    text-overflow: ellipsis;
    display: box;
    display: -webkit-box;
    -webkit-line-clamp:2;
   /*! autoprefixer: off */
    -webkit-box-orient: vertical;
  /* autoprefixer: on */
  }
  .fangshi{
    margin-top: 30px;
    width: 405px;
  }
  .fangshi ul,.fangshi ul li{
    width: 100%;
  }
  
  .fangshi ul li{
    list-style: none;
    font-size: 18px;
    color: rgb(102, 102, 102);
    margin-top: 25px;
    display: flex;
  
  }
  .fangshi ul li a{
    font-size: 18px;
    color: rgb(102, 102, 102);
    text-decoration: none
  }
  /* .fangshi p{
    display: inline-block;
    font-size: 18px;
    color: rgb(102, 102, 102)
  }
  .fangshi p a{
    text-decoration: none;
    font-size: 18px;
    color: rgb(102, 102, 102)
  } */
  .fangshi ul li img{
    height: 22px;
    width: 22px;
    vertical-align: sub;
  }
  .erweima{
    margin-left: 50px;
  }
  .erweima,.erweima img{
    width: 228px;
    height: 230px;
    object-fit: cover
  }
  .konglong{
    margin-top: 117px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/pcPages/Contact.vue